(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("instance-dispose", [], factory);
	else if(typeof exports === 'object')
		exports["instance-dispose"] = factory();
	else
		root["instance-dispose"] = factory();
})(self, function() {
return 